import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IAddDocumentInterventionResponse from 'services/httpClient/responses/intervention/IAddDocumentInterventionResponse';

import { interventionActions } from '../index';
import { IAddDocumentInterventionRequestAction } from '../reducers/addDocument/request';

function* addDocument(
  action: PayloadAction<IAddDocumentInterventionRequestAction>,
) {
  try {
    const formData = new FormData();

    formData.append('doc', action.payload.data.document);
    formData.append('file_type', action.payload.data.file_type);
    if (action.payload.data.price) {
      formData.append('price', action.payload.data.price.toString());
    }
    if (action.payload.data.vat) {
      formData.append('vat', action.payload.data.vat);
    }
    if (action.payload.data.invoiceNumber) {
      formData.append('invoice_number', action.payload.data.invoiceNumber);
    }
    const response: AxiosResponse<IAddDocumentInterventionResponse> =
      yield call(
        rikHttpClient.post,
        `interventions/${action.payload.data.id}/document`,
        formData,
      );

    yield put(
      interventionActions.addDocumentSuccess({ document: response.data }),
    );

    action.payload.functions.success();
    action.payload.functions.close();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.addDocumentFailure());
  }
}

export default addDocument;
